<div class="license-crud mm-page">
  <h2>{{_(KEYS.LICENSE.LICENSE)}}</h2>
  <div class="mm-info-layout">
    <dl class="mm-info-summary">
      <div>
        <dt><i class="fa fa-lock" aria-hidden="true"></i>{{_(KEYS.LICENSE.TYPE)}}</dt>
        <dd>myMedax 4</dd>
      </div>
      <div>
        <dt><i class="fa fa-user" aria-hidden="true"></i>{{_(KEYS.LICENSE.LICENSEE)}}</dt>
        <dd>{{license.name}}</dd>
      </div>
      <div>
        <dt><i class="fa fa-calendar" aria-hidden="true"></i>{{_(KEYS.LICENSE.VALID_UNTIL)}}</dt>
        <dd>{{validUntil || _(KEYS.LICENSE.UNLIMITED)}}</dd>
      </div>
    </dl>

    <div class="mm-info-panels">
      <section class="mm-info-panel" *ngIf="license && license.feature">
        <h3>{{_(KEYS.LICENSE.FEATURES)}}</h3>
        <ul class="mm-info-features">
          <ng-container *ngFor="let feature of licenseFeatures()">
            <li *ngIf="license.feature[feature] && featureMap.get(feature)">
              <i class="fa {{featureMap.get(feature).icon}}" aria-hidden="true"></i>
              <span>{{_(featureMap.get(feature).name)}}</span>
            </li>
          </ng-container>
        </ul>
      </section>

      <section class="mm-info-panel">
        <h3>{{_(KEYS.LICENSE.ADDONS)}}</h3>
        <dl class="mm-info-list">
          <div>
            <dt><i class="fa fa-paper-plane" aria-hidden="true"></i>{{_(KEYS.LICENSE.NUM_SURVEYS_PER_MONTH)}}</dt>
            <dd *ngIf="license.constraint && license.constraint.numSurveysPerMonth; else ulSurveys">
              {{numSubmittedSurveys}} / {{license.constraint.numSurveysPerMonth}}
            </dd>
            <ng-template #ulSurveys><dd>{{_(KEYS.LICENSE.UNLIMITED)}}</dd></ng-template>
          </div>
          <div>
            <dt><i class="fa fa-id-card" aria-hidden="true"></i>{{_(KEYS.LICENSE.NUM_QUESTIONNAIRES)}}</dt>
            <dd *ngIf="license.constraint && license.constraint.numQuest; else ulQuest">
              {{numQuestionnaires}} / {{license.constraint.numQuest}}
            </dd>
            <ng-template #ulQuest><dd>{{_(KEYS.LICENSE.UNLIMITED)}}</dd></ng-template>
          </div>
          <div>
            <dt><i class="fa fa-tablet" aria-hidden="true"></i>{{_(KEYS.LICENSE.NUM_DEVICES)}}</dt>
            <dd *ngIf="license.constraint && license.constraint.numDevices; else ulDevice">
              {{numDevices}} / {{license.constraint.numDevices}}
            </dd>
            <ng-template #ulDevice><dd>{{_(KEYS.LICENSE.UNLIMITED)}}</dd></ng-template>
          </div>
          <div *ngIf="license.feature && license.feature.thieme">
            <dt><i class="fa fa-book" aria-hidden="true"></i>{{_(KEYS.LICENSE.NUM_THIEME_SUBMISSIONS_PER_MONTH)}}</dt>
            <dd *ngIf="license.constraint && license.constraint.numThiemeSubmissionsPerMonth; else ulThieme">
              {{license.constraint.numThiemeSubmissionsPerMonth}}
            </dd>
            <ng-template #ulThieme><dd>{{_(KEYS.LICENSE.UNLIMITED)}}</dd></ng-template>
          </div>
          <div>
            <dt><i class="fa fa-globe" aria-hidden="true"></i>Domains</dt>
            <dd *ngIf="license.constraint && license.constraint.domains; else allDomains">
              <span class="mm-info-line" *ngFor="let domain of (license.constraint.domains || [])">{{domain}}</span>
            </dd>
            <ng-template #allDomains><dd>{{_(KEYS.LICENSE.UNLIMITED)}}</dd></ng-template>
          </div>
        </dl>
      </section>
    </div>
  </div>
</div>
